import { render, staticRenderFns } from "./EditMarket.vue?vue&type=template&id=47d24fcd&scoped=true"
import script from "./EditMarket.vue?vue&type=script&lang=js"
export * from "./EditMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d24fcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d24fcd')) {
      api.createRecord('47d24fcd', component.options)
    } else {
      api.reload('47d24fcd', component.options)
    }
    module.hot.accept("./EditMarket.vue?vue&type=template&id=47d24fcd&scoped=true", function () {
      api.rerender('47d24fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/marketgoods/EditMarket.vue"
export default component.exports